import React, { useEffect, useState } from 'react'

import { Col, Row, DataContainer } from 'Components/shared/Container'
import { H3, Text } from 'Components/shared/Typography'
import Input, { Checkbox } from 'Components/shared/Input'
import Image from 'Components/shared/Image'

import styled from '@emotion/styled'
import { Flex } from 'lese'
import { Select } from 'Components/shared/Select'

const InputContainer = styled(Flex)`
  grid-column: 1;
  margin: 16px;
  max-height: 5em;
  align-self: center;
`

export default ({ club, setSelectedClub, previewImages, setPreviewImages, masterClub }) => {
  const [logo, setLogo] = useState('https://via.placeholder.com/180x180.png?text=No+Image+Found')
  const [journeyOption, setJourneyOption] = useState(0)

  useEffect(async () => {
    const jOption = club.cmd_button_mode?._text === 'TCODE' ? 0 : 1

    setJourneyOption(jOption)
  }, [masterClub])

  return (
    <>
      <DataContainer>
        <Row>
          <H3 style={{ alignSelf: 'center' }}>Clients Name</H3>
          <InputContainer>
            <Input
              value={club.clubName ? decodeURI(club.clubName) : ''}
              style={{ width: '30vw' }}
              fullWidth
              onChange={e => {
                const val = e.target.value
                setSelectedClub({ ...club, clubName: val })
              }}
            />
          </InputContainer>
          <Image
            style={{
              width: 'auto',
              minHeight: '180px',
              maxHeight: '180px',
              marginLeft: 'auto',
              paddingRight: '100px'
            }}
            src={logo}
          />
        </Row>
        <Row style={{ flexDirection: 'row', display: 'flex', justifyContent: 'center' }}>
          <Col style={{ alignSelf: 'center', flexDirection: 'column', margin: 'auto' }}>
            <Text>App Code</Text>
            <Input
              value={club.clubId ? club.clubId : ''}
              onChange={e => {
                setSelectedClub({ ...club, clubId: e.target.value })
              }}
            />
          </Col>
          <Col style={{ alignSelf: 'center', flexDirection: 'column', margin: 'auto' }}>
            <Text>Journey Option</Text>
            <Select
              xAlign="flex-start"
              defaultIndex={journeyOption}
              options={['T-Code', 'Hidden']}
              style={{ backgroundColor: '#eef0f1', padding: '4px' }}
              onChange={e => {
                if (e.previousIndex === e.newIndex) return
                switch (e.newIndex) {
                  case 0:
                    setSelectedClub({ ...club, cmd_button_mode: { _text: 'TCODE' } })
                    break
                  case 1:
                    setSelectedClub({ ...club, cmd_button_mode: { _text: 'HIDDEN' } })
                    break
                  default:
                    break
                }
              }}
            />
          </Col>
          <Col
            style={{ alignSelf: 'center', flexDirection: 'column', margin: 'auto', width: '25%' }}
          >
            <Input
              type="file"
              accept="image/*"
              id="imageHeader"
              onChange={e => {
                setLogo(URL.createObjectURL(e.target.files[0]))
                setPreviewImages({
                  ...previewImages,
                  imageHeader: {
                    src: URL.createObjectURL(e.target.files[0]),
                    file: e.target.files[0]
                  }
                })
                setSelectedClub({
                  ...club,
                  logo: `${e.target.files[0].name.replace(/-/g, '')}`
                })
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Col style={{ alignSelf: 'center', flexDirection: 'column', margin: 'auto' }}>
            <Text>My Health Scan</Text>
            <Checkbox
              checked={club.my_health_scan?._text === 'YES'}
              onChange={e => {
                setSelectedClub({
                  ...club,
                  my_health_scan: e.target.checked ? { _text: 'YES' } : { _text: 'NO' }
                })
              }}
            />
          </Col>

          <Col style={{ alignSelf: 'center', flexDirection: 'column', margin: 'auto' }}>
            {club.my_health_scan?._text === 'YES' && (
              <div>
                <div>Show What it means to me button</div>
                <Checkbox
                  checked={club.show_what_it_means_to_me?._text === 'YES'}
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      show_what_it_means_to_me: e.target.checked
                        ? { _text: 'YES' }
                        : { _text: 'NO' }
                    })
                  }}
                />
              </div>
            )}
          </Col>

          <Col style={{ alignSelf: 'center', flexDirection: 'column', margin: 'auto' }}>
            {club.my_health_scan?._text === 'YES' && (
              <div>
                <Text>Enable Self-Enroll</Text>
                <Checkbox
                  checked={club.auto_enroll?._text === 'YES'}
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      auto_enroll: e.target.checked ? { _text: 'YES' } : { _text: 'NO' }
                    })
                  }}
                />
              </div>
            )}
          </Col>
        </Row>
      </DataContainer>
    </>
  )
}
